import { createNaturalMultiplicationTask, randInt, twoDigitByTwoDigitExplanation } from "./sharedNaturalMultiplication";

function pickData() {
  let a = randInt(12, 49);
  let b = randInt(12, 49);
  while (a % 10 === 0) a = randInt(12, 49);
  while (b % 10 === 0) b = randInt(12, 49);
  return { a, b, result: a * b };
}

const mod = createNaturalMultiplicationTask({
  type: "NaturalMulTwoDigitByTwoDigitTask",
  pickData,
  explain: twoDigitByTwoDigitExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
